module.exports = __webpack_public_path__ + "static/media/gdpr-icon.3075fc2d.svg";